<template>
    <div>
        <modal class="new-modal-default create-team"  :name="modal_name"  transition="nice-modal-fade" :delay="100"  :width="750" :height="420" :pivot-y="0.5" :adaptive="true" :scrollable="false" style="pointer-events:inherit !important" 
            v-bind:click-to-close="false">
            <div class="v-modal-content" style="background-color: #ffffff !important;">
                <!-- Header Section -->
                <div class="v-modal-header">
                    <span class="v-modal-dialog-title v-modal-title">CREATE TEAM</span>
                    <div>
                        <span class="icon icon-close mr-2 text-white pointer close-left" @click="hideCreateTeam()"></span>
                    </div>
                </div>
                <!-- Body Section -->
                <div class="v-modal-body overflow-hidden">
                    <div class="v-modal-layout px-3 py-2">
                        <div class="d-flex">
                            <div style="text-align:center;">
                                <span style="text-align:center;">
                                <hollow-dots-spinner v-if="img_loader" style="position: absolute;margin: 0;top: 22px;left:70px;display: flex;width: 108% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                <img v-if="profile_pic" :src="profile_pic" class="contact-image" alt="Product Pic"
                                    style="height: 6em; width: 6em; border-radius: 6px;border:1px solid #cdd2da;" />
                                <img v-else :src="imgDataUrl" class="contact-image" alt="Product Pic"
                                    style="height: 6em; width: 6em; border-radius: 6px;border:1px solid #cdd2da;" />
                                </span>
                                <upload-picture v-if="disableButtonAndDisplayLoader == false" @CallLoader="CallLoader" @uploadImage="uploadImage"></upload-picture>
                                <div v-if="disableButtonAndDisplayLoader == true" class="mt-4 pl-2">
                                    <button class="upload-pic-btn">Upload Picture</button>
                                </div>
                                </div>
                            <div class="form-group w-100 pl-5 pr-6">
                                <input class="inputFieldNew mt-6" type="text" maxlength="100" placeholder="Enter Team Name"
                                    name="team_name" v-model="createJson.team_name" v-validate="'required'" />
                                <label class="inputLabel fs-14 fw-600">
                                    Team Name<sup class="pl-1 fs-14 text-danger">*</sup>
                                </label>
                                <div class="fs-13 ">
                                    <span class="input-field-length float-right">{{ 100 - createJson.team_name.length }}/100</span>
                                    <span class="float-left text-danger" v-show="errors.has('team_name')">Team Name is Required</span>
                                </div>
                            </div>
                        </div>
                        <div class="row form-group w-100 pl-8 pr-2">
                            <input class="col-lg-7 col-md-7 col-sm-7 inputFieldNew email-name mt-6 convert-small" type="text" maxlength="100" placeholder="Enter Team Email ID"
                                name="team_email" v-model="createJson.team_email" v-on:keypress="validateEmail($event)" v-validate="{required: true}"/>
                            <input class="col-lg-5 col-md-5 col-sm-5 inputFieldNew email-domain mt-6" disabled type="text" placeholder="Enter Email Domain"
                                name="team_email" v-model="email_domain" />
                            <label class="inputLabel fs-14 fw-600">
                                Team Email<sup class="pl-1 fs-14 text-danger">*</sup>
                            </label>
                            <div class=" fs-13 ">
                                <span class="float-left text-danger" v-show="errors.has('team_email')">Team Email ID is Required</span>
                            </div>
                        </div>
                        <div class="row form-group w-100 pl-8 pr-0">
                            <div class="col-lg-12 col-md-12 col-sm-12 p-0">
                                <span class="fs-14 text-secondary fw-600">
                                    Team Owner<sup class="pl-1 fs-14 text-danger">*</sup>
                                </span>
                                <div class="d-flex">
                                    <multiselect
                                        class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-3"
                                        placeholder="Select Team Owner" track-by="id"
                                        label="full_name"
                                        name="team_owner"
                                        v-validate="'required'"
                                        v-model="createJson.team_owner"
                                        :options="owners_options"
                                        :multiple="false" :searchable="true" :internal-search="true"
                                        :clear-on-select="true" :close-on-select="true" :options-limit="400"
                                        :max-height="200" :show-no-results="true" :hide-selected="false"
                                        :blockKeys="['Delete']" :loading="owners_loading" @search-change="getOwnersData">
                                        <template slot="afterList">
                                            <div v-observe-visibility="reachedEndOfOwner" />
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                    </multiselect>
                                    <span class="mt-5 ml-1"><i class="icon text-orange icon-check-circle"></i></span>
                                </div>
                            </div>
                            <div class=" fs-13 ">
                                <span class="float-left text-danger" v-show="errors.has('team_owner')">Team Owner is Required</span>
                            </div>
                        </div>
                        <div class="form-group w-100 pl-5 pr-6 mt-2">
                            <span class="text-secondary whiteSpace fs-14 vselectLabel fw-600">
                                Description
                            </span>
                            <div class="d-flex align-items-center">
                                <textarea-autosize class="digi-textarea white-background bordered" maxlength="500" placeholder="Enter Description" v-model="createJson.description" style="height: 8em; overflow: auto;" />
                            </div>
                            <div class="text-right fs-13 mt-1">
                                <span class="input-field-length float-right">{{ 500 - createJson.description.length }}/500</span>
                            </div>
                        </div>
                    </div>
                    <!-- Buttons Section -->
                    <div v-if="disableButtonAndDisplayLoader == false" class="d-flex align-items-center justify-content-center w-100">
                        <button class="btn new-cancel-button mt-2" @click="hideCreateTeam()">Cancel</button>
                        <button class="btn new-save-button mt-2 ml-6" v-if="hideSaveButton == false" @click="validateAndSave()">Save</button>
                    </div>
                    <div v-else class="d-flex  align-items-center justify-content-center w-100">
                        <button class="btn new-cancel-button mt-2" style="border: 1px solid transparent !important;" disabled>Cancel</button>
                        <button class="btn btn-des-small mt-2 ml-6 btn-new-save" style="position: relative;" disabled>Save
                            <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                        </button>
                    </div>
                </div>
                <!-- <div class="v-modal-footer mb-4 mt-2">

                </div> -->
            </div>
        </modal>
        <sweet-modal ref="warning_modal" hide-close-button overlay-theme="dark" icon="warning">{{warning_msg}}</sweet-modal>
        <sweet-modal ref="success_modal" hide-close-button overlay-theme="dark" icon="success">{{success_msg}}</sweet-modal>
    </div>
</template>
<script>
import moment from 'moment';
import { SweetModal } from 'sweet-modal-vue';
import Teams from "../mixins/teams.js"
import { EventBus } from '../eventBus/nav-bar-event';
import myUpload from 'vue-image-crop-upload'
import UploadPicture from "../UploadPicture"
import { Result } from 'element-ui';
import { debounce } from 'lodash'
import { HollowDotsSpinner } from "epic-spinners";
export default {
    data(){
        return{
            disableButtonAndDisplayLoader: false,
            hideSaveButton: false,
            createJson: {
                team_name: '',
                team_email: '',
                team_owner: '',
                description: ''
            },
            success_msg: '',
            warning_msg: '',
            email_domain: '',
            company_id: '',
            owners_count: 0,
            owner_visible: false,
            owner_scrollable: false,
            owners_loading: false,
            owners_options: [],
            temp_owners_options: [],
            profile_pic: '',
            imgDataUrl: '/static/images/New_logo.svg',
            img_loader: false
        }
    },
    mixins: [Teams],
    props: ["modal_name"],
    components: {
        myUpload,
        UploadPicture,
        HollowDotsSpinner,
        SweetModal
    },
    methods: {
        //Validates email input field 
        validateEmail(event){
            if(event.keyCode == 64 || event.keyCode == 46 || event.keyCode == 40 || event.keyCode == 41 || event.keyCode == 91 || event.keyCode == 92 || event.keyCode == 93
            || event.keyCode == 58 || event.keyCode == 59 || event.keyCode == 60 || event.keyCode == 62 || event.keyCode == 44 || event.keyCode == 34){
                event.preventDefault();
            }
        },
        uploadImage (imgData) {
            this.profile_pic = imgData
            this.img_loader = false
        },
        cropSuccess(imgDataUrl, field) {
            this.profile_pic = imgDataUrl
        },
        hideCreateTeam(){
            this.$emit("hideCreateTeam")
        },
        validateAndSave(){
            this.$validator.validateAll().then(result =>{
                if(result){
                    this.saveData();
                }
            })
        },
        //API call to get owner data
        async getOwnersDataDebounce(){
            try{
                let params = {
                    skip: 0,
                    company_id: this.company_id,
                }
                let response = await this.getOwnersDataList(params)
                this.owners_options = response.response
                this.owners_count = this.temp_owners_options.length
            }catch(reason){

            }
        },
        //Lazy loading for owner API call
        async reachedEndOfOwner(reached){
            this.owner_visible = reached
            if (reached) {
                if (this.owner_scrollable == false) {
                    this.owners_loading = true
                    let params ={
                        skip: this.owners_count,
                        company_id: this.company_id,
                    }
                    let response = await this.getOwnersDataList(params)
                    this.temp_owners_options = response.response.length;
                    if (response.skip == this.owners_count) {
                        if (this.temp_owners_options > 0) {
                            let tempFiles = response.response;
                            tempFiles.forEach(el => {
                                this.owners_options.push(el);
                            });
                            this.owners_count += response.response.length;
                            this.owners_loading = false
                        } else {
                            this.owner_scrollable = true
                            this.owners_loading = false
                        }
                    }
                    this.owners_loading = false
                }
            }
        },
        //API call to get email domain data
        async getEmailDomains(){
            try{
                let response = await this.getEmailDomainsList(this.company_id)
                this.email_domain = "@" + response.response.domain
            }catch(reason){

            }
        },
        //API call to save new team
       async saveData(){
            this.disableButtonAndDisplayLoader = true;
           let temp_data = []
           if(this.loggedInUser.full_name == this.createJson.team_owner.full_name){
               temp_data = {
                   "name": this.loggedInUser.full_name,
                    "email_id": this.loggedInUser.primary_email,
                    "profile_pic": this.loggedInUser.profile_pic,
                    "user_id": this.loggedInUser.user_id,
               }
           } else {
               temp_data = {
                   "name": this.createJsonData.team_owner.full_name,
                    "email_id": this.createJsonData.team_owner.email,
                    "profile_pic": this.createJsonData.team_owner.profile_pic,
                    "user_id": this.createJsonData.team_owner.user_id,
               }
           }
            try{
                let params = {
                   "name": this.createJsonData.team_name,
                   "description": this.createJsonData.description,
                   "email_id": this.createJsonData.team_email,
                   "logo": this.createJsonData.profile_image,
                   "owner": temp_data,
                }
                var response = await this.createTeamData(params)
                if (response.status_id == 1) {
                    this.hideSaveButton = true
                    this.success_msg = response.message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.hideCreateTeam();
                        this.$router.push({
                            path: '/teams/TeamListView'
                        })
                        this.hideSaveButton = false
                        this.disableButtonAndDisplayLoader = false;
                        this.$refs.success_modal.close();
                        this.$emit("loadTeams")
                    }, 3000);
                } else {
                    this.warning_msg = response.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.disableButtonAndDisplayLoader = false;
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            } catch(error){
                this.warning_msg = error
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.disableButtonAndDisplayLoader = false;
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        CallLoader(){
            this.img_loader = true
        }
    },
    mounted(){
        this.createJson.team_owner = {
            full_name: this.loggedInUser.full_name
        }
        this.company_id = this.loggedInUser.company_id
        this.getEmailDomains();
    },
    created(){
        this.getOwnersData = debounce(this.getOwnersDataDebounce, 500)
    },
    computed: {
        loggedInUser() {
            return this.$store.state.loggedInUser;
        },
        createJsonData(){
            return {
                team_name: this.createJson.team_name,
                team_email: this.createJson.team_email + this.email_domain,
                team_owner: this.createJson.team_owner,
                description: this.createJson.description || "",
                profile_image: this.profile_pic || ""
            }
        },
    },
}
</script>
<style scoped>
    .btn-cancel-style {
        color: #E82828 !important;
        background-color: #fff;
        border: 1px solid #E82828
    }
    .btn-new-save {
        color: #fff;
        background-color: #1A9347;
    }
    .email-name{
        border-radius: 6px 0px 0px 6px !important;
        border-right: none !important;
    }
    .email-domain{
        background-color: #fff !important;
        border-radius: 0px 6px 6px 0px !important;
    }
    .owner-input{
        border: 1px solid #999;
        border-radius: 6px;
        border-bottom: none;
    }
    .upload-pic-btn{
        width: 140px;
        padding: 6px 0px;
        border-radius: 18px;
        font-size: 14px !important;
        font-weight: 500;
        color: gray;
        cursor: not-allowed;
        margin-left: 4px;
        margin-bottom: 15px;
    }
    .convert-small{
        text-transform: lowercase !important;
    }
    @media only screen and (max-width: 576px) {}
</style>


// WEBPACK FOOTER //
// src/components/Teams/CreateTeam.vue